import { type UseFieldValueOptions, useFieldValue } from "react-admin";

export const useTypedFieldValue = <
  Value,
  RecordType extends Record<string, unknown> = Record<string, unknown>,
>(
  params: UseFieldValueOptions<RecordType>,
): Value | undefined => useFieldValue(params) as Value | undefined;
